import qs from 'qs';
import Api from './baseService';
import type { CollectionModel, CreateCollectionRequest, DeleteCollectionRequest, UpdateCollectionRequest, } from '@/models';

async function getCollectionById(id: number): Promise<CollectionModel> {
  const url = `collections/${id}`;

  const response = await Api.get(url);
  return response.data as CollectionModel;
}

async function getCurrentUserCollections(): Promise<CollectionModel[]> {
  const url = 'collections/mine';

  const response = await Api.get(url);
  return response.data as CollectionModel[];
}

async function createCollection(request: CreateCollectionRequest): Promise<CollectionModel> {
  const response = await Api.post('collections', request);
  return response.data;
}

async function updateCollection(id: number, request: UpdateCollectionRequest): Promise<void> {
  await Api.put(`collections/${id}`, request);
}

async function deleteCollection(id: number, request: DeleteCollectionRequest): Promise<void> {
  let url = `collections/${id}`;

  if (request) {
    const query = qs.stringify(request);

    url = `${url}?${query}`;
  }

  await Api.delete(url);
}

export {
  getCollectionById,
  getCurrentUserCollections,
  createCollection,
  updateCollection,
  deleteCollection,
}
